import Vue from 'vue';

export default Vue.observable({
	groupsList: [],
	user: {
		name: '',
		email: '',
		imageUrl: '',
	},
	calculator: {
		monthlyIncome: '1.000.000,00',
		monthlySalaries: '100.000,00',
		monthlyConsumption: '100.000,00',
	}
});